// extracted by mini-css-extract-plugin
export default {"popupWrapper":"CustomPopup_popupWrapper__7Ysar","show":"CustomPopup_show__YaeFH","popupContent":"CustomPopup_popupContent__0I6wm","popUpBtn":"CustomPopup_popUpBtn__+gvSM"};